import type { Program, ProgramPostContentObjectList } from 'models';
import { can } from 'old/utils/permissions';
import { Flex } from 'ui';
import { Attachments } from 'features/attachments';
import { MarkAsRead } from '../../../mark-as-read';
import { Footer } from '../footer';
import { LongTextContent } from '../long-text-content';
import { ProgramTimelineItemHeader } from '../program-timeline-item-header';

type P = {
  'data-test-id'?: string;
  item: ProgramPostContentObjectList;
  program: Program;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
const ProgramPostTimelineItem = ({ 'data-test-id': dataTestId, item, program }: P) => {
  const isProgramPublished = program.status === 'published';

  return (
    <Flex data-test-id={dataTestId} gap={32} vertical>
      <ProgramTimelineItemHeader item={item} program={program} />

      <LongTextContent item={item} onCreateOrder={() => undefined} />

      {can(item.program, 'Program', 'contentCreator') ? null : (
        <div className="post-mark-as-read">
          <MarkAsRead postId={item.post.id} status={item.post.status} view="other" />
        </div>
      )}
      <Attachments attachments={item.attachments} />
      <Footer isProgramPublished={isProgramPublished} item={item} program={program} />
    </Flex>
  );
};

export default ProgramPostTimelineItem;
